// Form.jsx

import styles from '../../styles/module/SectionFindTable.module.css'; // Import module CSS
import inputStyles from '../../styles/module/Input.module.css'; // Import Input.module.css
import { getIcon } from "../../utils/helper.jsx";
import React, { useEffect, useState } from "react";
import reservationService from "../../services/reservationService.js";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'; // Import DatePicker styles

const Form = (props) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submissionError, setSubmissionError] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);

    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        person: '1',
        reservationDate: '',
        reservationTime: '11:30',
        message: '',
    });

    const [errors, setErrors] = useState({
        name: '',
        phone: '',
        reservationDate: '',
    });
    const [today, setToday] = useState('');

    useEffect(() => {
        const todayDate = new Date();
        const year = todayDate.getFullYear();
        let month = todayDate.getMonth() + 1;
        let day = todayDate.getDate();

        month = month < 10 ? '0' + month : month;
        day = day < 10 ? '0' + day : day;

        setToday(`${year}-${month}-${day}`);
        setSelectedDate(todayDate);
        setFormData(prevFormData => ({
            ...prevFormData,
            reservationDate: `${year}-${month}-${day}`
        }));
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    const handleChangeDate = (date) => {
        setSelectedDate(date);
        const year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();

        month = month < 10 ? '0' + month : month;
        day = day < 10 ? '0' + day : day;
        const formattedDate = `${year}-${month}-${day}`;


        if (formattedDate < today) {
            setErrors(prevErrors => ({
                ...prevErrors,
                reservationDate: 'Bitte wählen Sie ein Datum in der Zukunft.',
            }));
            setFormData(prevFormData => ({
                ...prevFormData,
                reservationDate: ''
            }));
        } else {
            setErrors(prevErrors => ({
                ...prevErrors,
                reservationDate: '',
            }));
            setFormData(prevFormData => ({
                ...prevFormData,
                reservationDate: formattedDate,
            }));
        }
    };

    const validateForm = () => {
        let isValid = true;
        const newErrors = { ...errors };

        if (!formData.name?.trim()) {
            newErrors.name = 'Bitte geben Sie Ihren Namen ein.';
            isValid = false;
        } else {
            newErrors.name = '';
        }

        if (!formData.phone?.trim()) {
            newErrors.phone = 'Bitte geben Sie Ihre Telefonnummer ein.';
            isValid = false;
        } else if (!/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/.test(formData.phone)) {
            newErrors.phone = 'Bitte geben Sie eine gültige Telefonnummer ein.';
            isValid = false;
        } else {
            newErrors.phone = '';
        }

        if (!formData.reservationDate) {
            newErrors.reservationDate = 'Bitte wählen Sie ein Reservierungsdatum aus.';
            isValid = false;
        } else {
            newErrors.reservationDate = '';
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setIsSubmitting(true);
            setSubmissionError(null);

            try {
                const reservationDate = new Date(formData.reservationDate);
                const responseData = await reservationService.createReservation({
                    name: formData?.name,
                    phoneNumber: formData?.phone,
                    partySize: Number(formData?.person) || 1,
                    reservationDate: reservationDate,
                    reservationTime: formData?.reservationTime,
                    status:0,
                    message: formData?.message,
                    tenant:"KANDO"
                });
                console.log('Reservation created successfully:', responseData);
                setErrors({});
                alert('erfolgreiche Reservierung');
            } catch (error) {
                console.error('Error submitting form:', error);
                setSubmissionError("Reservierung fehlgeschlagen");

                if (error.response && error.response.data && error.response.data.errors) {
                    setErrors(error.response.data.errors);
                }
            } finally {
                setIsSubmitting(false);
            }
        } else {
            console.log('Form has errors.');
        }
    };

    const renderPartySizeOptions = (maxSize = 64) => {
        const options = [];
        for (let i = 1; i <= maxSize; i++) {
            options.push(
                <option key={i} value={i}>
                    {i} {i === 1 ? "Person" : "Personen"}
                </option>
            );
        }
        return options;
    };

    const renderTimeOptions = () => {
        const timeSlots = [
            "11:30", "12:00", "13:00", "14:00", "15:00",
            "16:00", "17:00", "18:00", "19:00", "20:00",
            "21:00", "22:00"
        ];

        return timeSlots.map(timeSlot => (
            <option key={timeSlot} value={timeSlot}>
                {timeSlot} Uhr
            </option>
        ));
    };

    return (
        <form action="" className={`${styles.formContainer}`} onSubmit={handleSubmit}>
            <div className={`${styles.headline2} ${styles.textCenter}`}>Tisch reservieren</div>
            <div className={`${styles.formText} ${styles.textCenter}`}>Bitte füllen Sie alle Angaben aus</div>
            {submissionError && <div className={`${styles.errorMessage}`}>{submissionError}</div>}


            <div className={`${styles.inputWrapper}`}>
                <div className={`${styles.inputContainer}`}>
                    <input
                        type="text"
                        name="name"
                        placeholder="Ihr Name"
                        autoComplete="off"
                        className={inputStyles.inputField}
                        value={formData.name}
                        onChange={handleChange}
                    />
                    {errors.name && <div className={`${styles.errorMessage}`}>{errors.name}</div>}
                </div>

                <div className={`${styles.inputContainer}`}>
                    <input
                        type="tel"
                        name="phone"
                        placeholder="Telefonnummer"
                        autoComplete="off"
                        className={inputStyles.inputField}
                        value={formData.phone}
                        onChange={handleChange}
                    />
                    {errors.phone && <div className={`${styles.errorMessage}`}>{errors.phone}</div>}
                </div>
            </div>

            <div className={`${styles.inputWrapperParent}`}>
                <div className={`${styles.inputContainer}`}>
                    <div className={`${styles.iconWrapper}`}>
                        <div className={`${styles.icon}`}>{getIcon('person')}</div>
                        <select name="person" className={inputStyles.inputField} value={formData.person} onChange={handleChange}>
                            {renderPartySizeOptions()}
                        </select>
                        <div className={`${styles.icon} ${styles.end}`}>{getIcon('drop-down')}</div>
                    </div>
                    {errors.person && <div className={`${styles.errorMessage}`}>{errors.person}</div>}
                </div>

                <div className={`${styles.inputContainer}`}>
                    <div className={`${styles.iconWrapper}`}>
                        <DatePicker
                            selected={selectedDate}
                            onChange={handleChangeDate}
                            dateFormat="yyyy-MM-dd"
                            className={inputStyles.inputField}
                            placeholderText="Wähle ein Datum"
                            popperPlacement="right"
                            minDate={new Date()}
                        />
                    </div>
                    {errors.reservationDate && <div className={`${styles.errorMessage}`}>{errors.reservationDate}</div>}
                </div>

                <div className={`${styles.inputContainer}`}>
                    <div className={`${styles.iconWrapper}`}>
                        <div className={`${styles.icon}`}>{getIcon('clock')}</div>
                        <select name="reservationTime" className={inputStyles.inputField} value={formData.reservationTime} onChange={handleChange}>
                            {renderTimeOptions()}
                        </select>
                        <div className={`${styles.icon} ${styles.end}`}>{getIcon('drop-down')}</div>
                    </div>
                    {errors.reservationTime && <div className={`${styles.errorMessage}`}>{errors.reservationTime}</div>}
                </div>
            </div>

            <textarea
                name="message"
                placeholder="Nachricht"
                autoComplete="off"
                className={inputStyles.inputField}
                value={formData.message}
                onChange={handleChange}
            />


            <button disabled={isSubmitting} type="submit" className={`hover-filled-slide-right ${styles.actionSend}`}
                   >
                <span> Senden</span>
            </button>
        </form>
    );
};

export default Form;